exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pie-label {\n  font-weight: bold;\n  font-size: 14px;\n  color: #4a4a4a; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Chart/RadialChart/PercentLabel/style.scss
// module id = 1036
// module chunks = 0